
/**
 * @class CustomItemTypeCodeUI
 * @classdesc Class definition for controlling the ui of the page.
 * @property {STRING} _id - The id of the custom item type code.
 * @property {STRING} _customItemTypeCode - The custom item type code ui.
 * @property {OBJECT} _itemTypeMapping - The item type mapping ui.
 * @property {OBJECT} _mobile - The mobile ui.
 */
export default class CustomItemTypeCodeUI {
    constructor(record) {
        this.id = record.id;
        this.customItemTypeCode = record.customItemTypeCode;
        this.itemTypeMapping = record.itemTypeMapping;
        this.mobile = record.mobile;
    }

    /**
     * @name id
     * @instance
     * @property set {STRING} - sets the id
     * @memberof CustomItemTypeCodeUI
     */
    set id(value) { this._id = value; }

    /**
     * @name customItemTypeCode
     * @instance
     * @property set {STRING} - sets the custom item type code
     * @memberof CustomItemTypeCodeUI
     */
    set customItemTypeCode(value) { this._customItemTypeCode = value; }

    /**
     * @name itemTypeMapping
     * @instance
     * @property set {OBJECT} - sets the item type mapping
     * @memberof CustomItemTypeCodeUI
     */
    set itemTypeMapping(value) { this._itemTypeMapping = value; }
    /**
     * @name mobile
     * @instance
     * @property set {OBJECT} - sets the mobile
     * @memberof CustomItemTypeCodeUI
     */
    set mobile(value) { this._mobile = value; }
    /**
     * @name id
     * @instance
     * @property get {STRING} - returns the id
     * @memberof CustomItemTypeCodeUI
     */
    get id() { return this._id; }

    /**
     * @name customItemTypeCode
     * @instance
     * @property get {STRING} - returns the custom item type code
     * @memberof CustomItemTypeCodeUI
     */
    get customItemTypeCode() { return this._customItemTypeCode; }

    /**
     * @name itemTypeMapping
     * @instance
     * @property get {OBJECT} - returns the item type mapping
     * @memberof CustomItemTypeCodeUI
     */
    get itemTypeMapping() { return this._itemTypeMapping; }

    /**
     * @name mobile
     * @instance
     * @property get {OBJECT} - returns the mobile
     * @memberof CustomItemTypeCodeUI
     */
    get mobile() { return this._mobile; }

    /**
     * @name record
     * @instance
     * @property get {OBJECT} - returns the set values
     * @memberof CustomItemTypeCodeUI
     */
    get record() {
        return {
            id: this.id,
            customItemTypeCode: this.customItemTypeCode,
            itemTypeMapping: this.itemTypeMapping,
            mobile: this.mobile
        };
    }

    static defaultValues = {
        id: "0",
        customItemTypeCode: undefined,
        itemTypeMapping: { isActive: false },
        mobile: { isActive: false }
    }

    reset() {
        return CustomItemTypeCodeUI.init(this.defaultValues);
    }
    
    static init(record) {
        const vals = { 
            ...this.defaultValues,
            ...record ?? {} 
        }
        return new CustomItemTypeCodeUI(vals);
    }
}